import animatedNumber from '@/components/animated-number/animated-number.vue';
import brandName from '@/components/brand-name/brand-name.vue';
import vimeoPlayer from '@/components/generics/vimeo-player/vimeo-player.vue';
import youtubePlayer from '@/components/generics/youtube-player/youtube-player.vue';
import marketStateTooltip from '@/components/market/market-state-tooltip/market-state-tooltip.vue';
import assetCdnSrcDirective from '@/directives/asset-cdn-src';
import clickOutsideDirective from '@/directives/click-outside';
import contractNameDirective from '@/directives/contract-name';
import largeNumberDirective from '@/directives/large-number';
import outerLinkDirective from '@/directives/outer-link';
import priceDisplayDirective from '@/directives/price-display';
import stickyDirective from '@/directives/sticky';

export default function registerGlobals(app) {
  app.directive('click-outside', clickOutsideDirective);
  app.directive('outer-link', outerLinkDirective);
  app.directive('price-display', priceDisplayDirective);
  app.directive('large-number', largeNumberDirective);
  app.directive('sticky', stickyDirective);
  app.directive('asset-cdn-src', assetCdnSrcDirective);
  app.directive('contract-name', contractNameDirective);

  app.component('brand-name', brandName);
  app.component('animated-number', animatedNumber);
  app.component('market-state-tooltip', marketStateTooltip);
  app.component('youtube', youtubePlayer);
  app.component('vimeo-player', vimeoPlayer);

  return app;
}
